module.exports = __webpack_public_path__ + "img/records-processing-en.c7eca9ab.png";